import { createIndicator } from '~/modules/SDK/indicator/createIndicator'
import { PineJS } from '~/modules/SDK/Chart2/PineJS'

export const gd1788_power = createIndicator({
  displayName: '力道',
  id: 'gd1788-power',
  constructorScope: {
    init(context, inputCallback) {
      const ticker = this.PineJS.Std.ticker(context)
        .toString()
        .replace(/[^\w-]/g, '')

      const symbol = ticker + '#bs_indicator_acc'

      context.new_sym(symbol, this.PineJS.Std.period(this._context))
    },
    main(context, inputCallback) {
      context.select_sym(1)

      // You can use following built-in functions in PineJS.Std object:
      // 	open, high, low, close
      //	hl2, hlc3, ohlc4
      const h = this.PineJS.Std.high(this._context)
      const l = this.PineJS.Std.low(this._context)
      const o = this.PineJS.Std.open(this._context)

      const colorIndex = o >= 0 ? 0 : 1

      return [o, colorIndex]
    },
  },
  metainfo: {
    precision: 2,
    //宣告
    plots: [
      {
        id: 'vol',
        type: 'line',
      },

      {
        id: 'volumePalette',
        type: 'colorer',
        target: 'vol',
        palette: 'volumePalette',
      },
    ],
    palettes: {
      volumePalette: {
        colors: {
          0: {
            name: '能量',
          },
          1: {
            name: '能量',
          },
        },
      },
    },

    defaults: {
      //樣式調整
      styles: {
        //--
        vol: {
          linestyle: 0,
          linewidth: 5,
          plottype: 5,
          trackPrice: !1,
          transparency: 0,
          visible: !0,
          color: '#ff8800',
        },
      },
      //填充區域
      palettes: {
        volumePalette: {
          colors: {
            0: {
              color: '#f44336',
              width: 0,
              style: 0,
            },
            1: {
              color: '#00aa33',
              width: 0,
              style: 0,
            },
          },
        },
      },
    },
    styles: {
      vol: {
        title: '能量',
        histogramBase: 0,
        joinPoints: !1,
      },
    },
    is_price_study: !1,
    inputs: [],
    scriptIdPart: '',
  },
})
